import React from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'

import AgentLayout from '../../_template/layout/AgentLayout'
import Agent from '../pages/agent/Agent'

const AgentRoute = () => {
    return (
        <>
            <Routes>
                <Route element={<AgentLayout />}>
                    <Route index element={<Navigate to='/agent' />} />
                    <Route path='/agent' element={<Agent />} />
                </Route>
                <Route path='*' element={<Navigate to="/error" />} />
            </Routes>
        </>
    )
}

export default AgentRoute